import { WorkItemTypes } from '../constants/workitem-types';
import { WorkItemBase } from './workitem-base-model';
import { DiscussionItem } from '../interfaces/discussion-item.interface';
import { ThemeServiceHelper } from 'common/theme/service.helper';
import * as _ from 'lodash';

export class WorkItemDiscussion extends WorkItemBase implements DiscussionItem {
  public readonly type: string = WorkItemTypes.DISCUSSION;

  ItemID: string;
  WorkItemID: string;
  WorkItemType: number;
  OperatorID: string;
  Created: string;
  Accepted: string;
  Ended: string;
  Deleted: string;
  OperatorName: string;
  messages?: object[];

  static wrap(event) {
    if (event.data) {
      return new WorkItemDiscussion(event.data);
    } else {
      return null;
    }
  }

  constructor(workItem) {
    super(workItem);

    if (workItem) {
      this.decorateWithDefaultValues(workItem);
    }

    this._avatarThemeId = ThemeServiceHelper.getAvatarThemeId(this.WorkItemID);
    this.keepAlive = false;
  }

  decorateWithDefaultValues(values) {
    _.assign(this, values);
  }
}
